import { type CSSProperties, type JSX } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons'

export function Loader(props: {size: number}): JSX.Element{
    const style: CSSProperties = {borderWidth: props.size * 0.125};
    return (
        <FontAwesomeIcon spin icon={faAsterisk} style={style} className='fa-icon' />
    );
}
